/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/event";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/event";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// TYPES ///
import { ISelfOrderEvent } from "api/types/event";
/// URLS ///
import { self_order_event_url } from "../../endpoint";
import { url_prefix } from "settings";

export const updateSelfOrderEvent = (event: ISelfOrderEvent, id: number | string, notify_customer: boolean = false) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.EVENT_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    let url = `${url_prefix}${self_order_event_url}/${id}/?`;

    if (notify_customer) {
      url += `notify_customer=true`;
    }

    try {
      const { data } = await axios.patch(url, event, config);

      dispatch({
        type: ActionType.UPDATE_SELF_ORDER_EVENT,
        self_order_event: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.EVENT_ERROR,
          error: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
